import { DataTableCol } from "../../../components/tables/types";

export const CollegeDataGridCols: DataTableCol[] = [
    {
        title: 'Title',
        control: 'collegeName',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Description',
        control: 'description',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true
    },
];